import { useScreens } from "vue-screen-utils";
import { useTailwindScreens } from "#imports";
export const useCalendarScreens = () => {
  const screens = useTailwindScreens();
  const utilities = useScreens(screens);
  return {
    ...utilities,
    screens
  };
};
